import { useState } from 'react';
import PhotoViewer from '../PhotoViewer';
import FileViewerLazy from '../FileViewerLazy';

/**
 * A memo's content: the message (plain text, line breaks kept), HQ's images
 * under it — tap one to see it whole and swipe through the rest — and the
 * signed PDF, which opens in the app's file viewer (zoom, Share).
 *
 * The viewers sit in a layer of their own above everything: the memo itself may
 * be on the pop-up sheet or the desktop modal, both of which are above where a
 * viewer normally opens.
 */
const card = { background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 14 };
const layer = { position: 'fixed', inset: 0, zIndex: 7000 };

export default function MemoBody({ memo }) {
  const [photo, setPhoto] = useState(null);
  const [file, setFile] = useState(false);
  const images = (memo.images || []).filter((i) => i.url);

  return (
    <div>
      {memo.body ? (
        <div style={{ fontSize: 13.5, lineHeight: 1.55, whiteSpace: 'pre-line', overflowWrap: 'anywhere' }}>{memo.body}</div>
      ) : null}

      {images.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: memo.body ? 14 : 0 }}>
          {images.map((img, i) => (
            <button
              key={img.url}
              type="button"
              onClick={() => setPhoto(i)}
              aria-label={`Open image ${i + 1}`}
              style={{ ...card, padding: 0, overflow: 'hidden', cursor: 'zoom-in', background: 'var(--bg)', display: 'block', width: '100%' }}
            >
              <img src={img.url} alt={`Memo image ${i + 1}`} loading="lazy" style={{ display: 'block', width: '100%', maxHeight: 420, objectFit: 'contain' }} />
            </button>
          ))}
        </div>
      )}

      {memo.attachment && (
        <div
          role="button"
          tabIndex={0}
          onClick={() => setFile(true)}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setFile(true); } }}
          style={{ ...card, display: 'flex', alignItems: 'center', gap: 12, padding: '11px 13px', marginTop: 14, cursor: 'pointer' }}
        >
          <span style={{ width: 34, height: 34, borderRadius: 9, flex: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: 'color-mix(in srgb,#cf1322 10%,var(--surface))', color: '#cf1322', fontSize: 10, fontWeight: 800 }}>PDF</span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 13, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{memo.attachment.name}</div>
            <div style={{ fontSize: 11.5, color: 'var(--muted)' }}>Tap to open</div>
          </div>
          <span style={{ color: 'var(--muted)' }}>›</span>
        </div>
      )}

      {photo != null && (
        <div style={layer}>
          <PhotoViewer open photos={images.map((i) => i.url)} start={photo} title={memo.title} alt={memo.title} onClose={() => setPhoto(null)} />
        </div>
      )}
      {file && memo.attachment?.url && (
        <div style={layer}>
          <FileViewerLazy title={memo.attachment.name} url={memo.attachment.url} fileName={memo.attachment.name} onClose={() => setFile(false)} />
        </div>
      )}
    </div>
  );
}
